import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import { get } from "lodash";
import {
  buildAutocompleteQueryConfig,
  buildSearchOptionsFromConfig,
  getConfig,
  buildFacetConfigFromConfig,
  getParametricFacet
} from "./faq-config-helper";
import appConfig from "../../config";

export const globalFilter = [
  { any: [{ ps_category: appConfig.parametricProduct }] },
  { any: [{ language_code: appConfig.appLanguage }] },
  {operation: ['U', 'u']}
];

const buildApiConnector = (filterFromQueryParams) => {
  const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();
  const connector = new AppSearchAPIConnector({
    searchKey,
    engineName,
    hostIdentifier,
    endpointBase,
    beforeSearchCall: (existingSearchOptions, next) => {
      const { filters } = existingSearchOptions;
      const newFilters = {
        all: [
          ...globalFilter,
          ...filterFromQueryParams,
          ...get(filters, "all", []).map(({ all }) => ({ any: all }))
        ]
      };

      const sort = get(existingSearchOptions, 'sort', []);
      if (sort.length === 0) {
        sort.push({
          id: 'asc'
        });
      }
      return next({
        ...existingSearchOptions,
        filters: newFilters,
        sort
      });
    }
  });
  return connector;
};

const buildFilterFromQueryParams = (searchParams) => {
  const paramCategory2 = searchParams.get('category_2');
  return paramCategory2 === null ? [] :
    [
      {
        any: [{
          relay_mosfet_14: paramCategory2,
        }],
      },
    ];
};

const buildConfig = (searchParams) => {
  const filterFromQueryParams = buildFilterFromQueryParams(searchParams);
  const connector = buildApiConnector(filterFromQueryParams);
  return {
    searchQuery: {
      disjunctiveFacets: getParametricFacet().map(f => f.field),
      facets: buildFacetConfigFromConfig(),
      ...buildSearchOptionsFromConfig()
    },
    autocompleteQuery: buildAutocompleteQueryConfig(),
    apiConnector: connector,
    alwaysSearchOnInitialLoad: true,
    trackUrlState: false,
    initialState: {
      resultsPerPage: 100
    }
  };
};

export default buildConfig;
